import React from "react";
import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";

const CustomizeImageDialogue = ({
  showDialog,
  image,
  handleFileSave,
  onClose,
}) => {
  const cropperRef = React.useRef(null);

  const handleCrop = () => {
    if (cropperRef.current) {
      const croppedCanvas = cropperRef.current?.cropper.getCroppedCanvas();
      if (croppedCanvas) {
        croppedCanvas.toBlob((blob) => {
          const file = new File([blob], "cropped-image.png", {
            type: "image/png",
          });
          handleFileSave(file);
          onClose(); // Close the modal after saving
        }, "image/png");
      }
    }
  };

  if (!showDialog) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96 shadow-xl">
        <h2 className="text-lg font-semibold mb-4">Customize Your Image</h2>
        {image && (
          <div>
            <Cropper
              src={image}
              style={{ height: 300, width: "100%" }}
              aspectRatio={1}
              guides={false}
              ref={cropperRef}
            />
            <div className="flex justify-between mt-4">
              <button
                onClick={handleCrop}
                type="button"
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                Save & Upload
              </button>
              <button
                onClick={onClose}
                type="reset"
                className="bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomizeImageDialogue;
